import {
  pipe,
  pluck,
  flatten,
  indexBy,
  prop,
  filter,
  pick,
} from 'ramda';
import { Mixpanel } from '../components/mixpanel';

export const getQuestions = questionnaire => pipe(
  pluck('questions'),
  flatten,
  filter(n => n),
)(questionnaire);

export const getCampaign = (url) => {
  if (url.match('app')) return 'app';
  return 'www';
};

export const getSchemaFromQuestionnaire = questionnaire => pipe(
  pluck('questions'),
  flatten,
  indexBy(prop('inputName')),
  pluck('validation'),
  filter(n => n),
)(questionnaire);

export const getSchemaFromGoal = goal => pipe(
  prop('questions'),
  indexBy(prop('inputName')),
  pluck('validation'),
  filter(n => n),
)(goal);

export const getUserAgeFromGoal = goal => pipe(
  pick(['age']),
)(goal);

export const getUserSavingsFromGoal = goal => pipe(
  pick(['current_savings']),
)(goal);

export const getQuestionsNames = questionnaire => pipe(
  pluck('questions'),
  flatten,
  filter(n => n),
  pluck('inputName'),
)(questionnaire);

export const getGoalNames = questionnaire => pipe(
  pluck('value'),
  flatten,
  filter(n => n),
)(questionnaire);

export const withCommas = number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const getMaxQuestions = questionnaire => pipe(
  pluck('totalQuestions'),
  flatten,
  filter(n => n),
)(questionnaire);

export const stringToNumber = (str = '') => Number(str.replace(/,/g, ''));

export const mp = (string) => {
  Mixpanel.only.mp(string)
};

const ua = window.navigator.userAgent;
const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
const webkit = !!ua.match(/WebKit/i);
export const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

export function getCookie(id){
  const b = document.cookie.match(
    '(^|;)\\s*' + id + '\\s*=\\s*([^;]+)',
  );
  return b ? b.pop() : ''
}

export function getUtmVarsFromEncodedUri(url) {
  var querystring = decodeURIComponent(url).split("?");
  let utm_values = {}
  if (querystring.length > 1) {
    var pairs = querystring[1].split("&");
    for (const i in pairs) {
      var keyval = pairs[i].split("=");
      utm_values[keyval[0]] = keyval[1]
    }
  }
  return utm_values;
}